import { useCallback, useEffect, useState } from "react";
import { AUDIO_TONES_BY_CHANNEL } from "../constants/audioCatalog";
import { playAudioTone, setActiveAudioToneVolume, stopAudioTone } from "../helpers/playAudioTone";
import { AudioChannel, AudioToneId } from "../types";

type ActiveAudioPreview = {
  channel: AudioChannel;
  toneId: AudioToneId;
} | null;

export const useAudioPreview = () => {
  const [activePreview, setActivePreview] = useState<ActiveAudioPreview>(null);

  const stopPreview = useCallback(() => {
    stopAudioTone();
    setActivePreview(null);
  }, []);

  const preview = useCallback((channel: AudioChannel, toneId: AudioToneId, volume: number) => {
    if (activePreview?.channel === channel && activePreview.toneId === toneId) {
      stopPreview();
      return;
    }

    const tone = AUDIO_TONES_BY_CHANNEL[channel].find((item) => item.id === toneId);
    if (!tone) return;

    setActivePreview({ channel, toneId });
    void playAudioTone(tone, volume);
  }, [activePreview, stopPreview]);

  const setPreviewVolume = useCallback(
    (channel: AudioChannel, volume: number) => {
      if (activePreview?.channel !== channel) return;

      setActiveAudioToneVolume(volume);
    },
    [activePreview],
  );

  useEffect(() => () => stopAudioTone(), []);

  return {
    activePreview,
    preview,
    setPreviewVolume,
    stopPreview,
  };
};
